import { computed, inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Organization } from './organization.model';
import { EnvConfigService } from '../core/env-config/env-config.service';

@Injectable({
  providedIn: 'root',
})
export class OrganizationService {
  private config = inject(EnvConfigService);

  readonly apiUrl = computed(() => this.config.config().api.studyManager);

  private http = inject(HttpClient);

  getCurrentOrganization(id: string | number): Observable<Organization> {
    return this.http.get<Organization>(`${this.apiUrl()}/api/v1/organizations/${id}/`);
  }
}
